export function NotFoundPage() {
  return (
    <div>
      <h1>Not found</h1>
      <p className="muted">This client route does not exist.</p>
    </div>
  );
}
